module.exports = __webpack_public_path__ + "static/media/wajdi.f5a14c40.jpeg";